import React, { PureComponent, Fragment } from 'react'
import { connect } from 'react-redux'

import FlowManager from 'components/FlowManager'
import { STEP_COUNT_TOTAL, DEMO_REQUEST_STEP_COUNT, ONBOARDING_STEP_COUNT } from '../constants'
import { getCustomerSegment } from 'modules/billing/selectors'

import DemoRequestPlaybookFlowRoutes from './routes'

const STEP_TOTAL = STEP_COUNT_TOTAL - DEMO_REQUEST_STEP_COUNT
const STEP_OFFSET = ONBOARDING_STEP_COUNT + 1

const mapStateToProps = (state) => {
  return {
    segment: getCustomerSegment(state)
  }
}

class DemoRequestPlaybookFlow extends PureComponent {

  onDone = () => {
    const { history } = this.props
    history.push('/onboarding/playbook/targeting')
  }

  render() {
    const { match, history, segment } = this.props

    return (
      <Fragment>
        <FlowManager steps={DemoRequestPlaybookFlowRoutes} stepTotal={STEP_TOTAL} stepOffset={STEP_OFFSET} baseUrl={match.url} history={history} onDone={this.onDone} segment={segment} name='Playbook Onboarding'/>
      </Fragment>
    )
  }
}

export default connect(mapStateToProps, null)(DemoRequestPlaybookFlow)



// WEBPACK FOOTER //
// ./src/flows/OnboardingFlow/OnboardingDemoRequestPlaybookFlow/index.js